import React, { useEffect } from "react";
import AdsByGoogle from "../vendor/AdsByGoogle"
import { IS_TABOOLA } from "../../common/constants/constants";

const ArticleRecomendations = () => {
	if (window.TESTING_MODE) {
		return null;
	} else if (window.BRAND === "aszdziennik" && !IS_TABOOLA) {
		return <AdsByGoogle />;
	} else {
		return null
	}
}

export default ArticleRecomendations